export class DialogSessionTimeoutData {
	/**
	 * Constructeur.
	 * @param sessionTimeout : Date d'expiration de la session.
	 * @param sessionNotificationDelay :  Delai (en secondes) avant l'expiration de la session pour afficher la notification à l'utilisateur.
	 */
	public constructor(
		public sessionTimeout: Date,
		public sessionNotificationDelay: number
	) {}
}
